function MatchHeight() {
  jQuery(".horizontal-product__info a").matchHeight();
  jQuery(".image-link-blocks__title").matchHeight();
  jQuery(".image-link-blocks__item").matchHeight();
  jQuery(".multi-column__item   .v-stack .h3").matchHeight();
  jQuery(".multi-column__item   .v-stack .h4").matchHeight();
  jQuery(".multi-column__item   .v-stack .h2").matchHeight();
  jQuery(".multi-column__item   .v-stack .h5").matchHeight();
  jQuery(".multi-column__item  .prose>p").matchHeight();
  jQuery(".blog-post-card__info .v-stack  .h3>a ").matchHeight();
  jQuery(".blog-post-card__info .v-stack > p ").matchHeight();
  jQuery(".product-card__title").matchHeight();
  jQuery(".product-card__info .rating-with-text.w-full .text-xs").matchHeight();
  jQuery(".product-card__price").matchHeight();
  jQuery(".image-link-blocks__inner .img-block-equal").matchHeight();
}

$(document).ready(function() {

  $(document).on('click', '.header__link-list .cst-li-3 a.dropdown-menu__item, .header__link-list .cst-li-4 li:first a.dropdown-menu__item, .footer__block--menu .cst-ful-3 .cst-fli-1 a, .footer__block--menu .cst-ful-4 .cst-fli-1 a, .footer__block--menu .cst-ful-4 .cst-fli-2 a, .cst-index .shopify-section--hot-spots a.button, .cst-index .shopify-section--rich-text a.button', function(e){ 
      e.preventDefault(); 
      var url = $(this).attr('href'); 
      window.open(url, '_blank');
  }); 
  
  /*-- START ==> Added last removed product logic --*/
  var retrievedObject = localStorage.getItem('cst_last_removed_item');
  if(retrievedObject){
    $('.cst-product-undo').removeClass('hidden');
    var lastRemovedPDP = JSON.parse(retrievedObject);
    
    $('.cst-product-undo pdp').text(lastRemovedPDP['title']);
    $('.cst-undo').attr('data-qty',parseInt(lastRemovedPDP['qty']));
    $('.cst-undo').attr('data-id',parseInt(lastRemovedPDP['id']));

    // setTimeout(function() {
    //   $('.cst-product-undo').removeClass('hidden');
    //   setTimeout(function() {
    //     $('.cst-product-undo').addClass('hidden');
    //   }, 3000);
    // }, 0);
  }

  $(document).on('click', '.link.cst-remove', function(e) {
    var cst_VID = $(this).closest('span.text-xs').attr("data-id");
    var cst_QTY = $(this).closest('span.text-xs').attr("data-qty");
    var cst_PTITLE = $(this).closest('span.text-xs').attr("data-title");

    const myObj = {'id':cst_VID,'qty':cst_QTY,'title':cst_PTITLE};
    localStorage.setItem('cst_last_removed_item', JSON.stringify(myObj));
  });

  $(document).on('click', '.cartpage.cst-undo', function(e) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: $(this).attr('data-qty'),
        id: $(this).attr('data-id')
      },
      dataType: 'json',
      success: function() {
        localStorage.removeItem("cst_last_removed_item");
        location.reload();
      },
      error: function() {
        // Handle error
      }
    });
  });

  $(document).on('click', '.cartdrawer.cst-undo', function(e) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: $(this).attr('data-qty'),
        id: $(this).attr('data-id')
      },
      dataType: 'json',
      success: function() {
        localStorage.removeItem("cst_last_removed_item");
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
      },
      error: function() {
        // Handle error
      }
    });
  })
  /*-- END ==> Added last removed product logic --*/

  

  // Other event handlers...

  $("input[name='contact[Phone]']").keypress(function(e) {
    var charCode = e.which ? e.which : event.keyCode;
    if (String.fromCharCode(charCode).match(/[^0-9+]/g)) return !1;
  });

  MatchHeight();

  $(".sub-link.active").parent("ul").parent("div").parent("details").parent("li").addClass("active");
  $(".sub-sub-link.active").parent("ul").parent("li").parent("ul").parent("div").parent("details").parent("li").addClass("active");

  jQuery(document).on("click", "#products .collection__facets, .facets-summary, .collection__results .active-facets, #facets-drawer", function(event2) {
    console.log("filter1");
    setTimeout(function() {
      MatchHeight();
    }, 1000);
  });

  jQuery(document).on("click", ".collection__pagination .pagination__item.group", function(event2) {
    console.log("page 1");
    setTimeout(function() {
      MatchHeight();
    }, 1000);
  });

  $(window).on("load", function() {
    MatchHeight();
  });
});